var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m-grid__item m-grid__item--fluid m-wrapper" },
    [
      _c("div", { staticClass: "m-subheader" }, [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("div", { staticClass: "mr-auto" }, [
            _c(
              "h3",
              {
                staticClass: "m-subheader__title m-subheader__title--separator"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("titleize")(
                        _vm._f("translate")("system_administration")
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("ul", {
              staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline"
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-content" },
        [
          _c("div", { staticClass: "m-portlet m-portlet--tab" }, [
            _c("div", { staticClass: "m-portlet__head" }, [
              _c("div", { staticClass: "m-portlet__head-caption" }, [
                _c("div", { staticClass: "m-portlet__head-title" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("h3", { staticClass: "m-portlet__head-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("sections"))
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m-portlet__head-tools" }, [
                _vm.validPermission("create", "section")
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-success m-btn m-btn--icon",
                        attrs: {
                          "data-toggle": "modal",
                          "data-backdrop": "static",
                          "data-keyboard": "false",
                          "data-target": "#sections_modal"
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateStateSectionModal(true)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _c("i", { staticClass: "fa flaticon-app" }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("create_section")
                                )
                              )
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-portlet__body" },
              [
                _c("s-datatable", {
                  attrs: { config: _vm.datatable },
                  scopedSlots: _vm._u([
                    {
                      key: "actions",
                      fn: function(props) {
                        return _c("div", {}, [
                          _vm.validPermission("modify", "section")
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                                  attrs: {
                                    "data-toggle": "modal",
                                    "data-backdrop": "static",
                                    "data-keyboard": "false",
                                    "data-target": "#sections_modal",
                                    title: _vm._f("translate")("edit_details")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editSection(props.row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "la la-edit" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.validPermission("change", "section")
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_delete",
                                  attrs: {
                                    title: _vm._f("translate")("modify")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.modifySection(props.row.id)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "la la-leaf" })]
                              )
                            : _vm._e()
                        ])
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "s-modal",
            {
              attrs: {
                id: "sections_modal",
                title: _vm._f("capitalize")(
                  _vm._f("translate")(
                    _vm.modal_permision && !_vm.modal_phrases
                      ? "create_permission"
                      : _vm.modal_phrases
                      ? "create_phrases"
                      : _vm.is_edit
                      ? "edit_section"
                      : "create_section"
                  )
                )
              }
            },
            [
              _c("s-section-form", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.modal_phrases && !_vm.modal_permision,
                    expression: "!modal_phrases && !modal_permision"
                  }
                ],
                attrs: { slot: "body", data: _vm.model },
                slot: "body"
              }),
              _vm._v(" "),
              _c("s-new-phrase", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_phrases,
                    expression: "modal_phrases"
                  }
                ],
                attrs: { slot: "body", data: _vm.phrase, openOutside: true },
                slot: "body"
              }),
              _vm._v(" "),
              _c("s-base-form", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modal_permision && !_vm.modal_phrases,
                    expression: "modal_permision && !modal_phrases"
                  }
                ],
                attrs: {
                  slot: "body",
                  pModel: _vm.model,
                  isProfile: false,
                  isEdit: false,
                  openOutside: true
                },
                slot: "body"
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon m--hide" }, [
      _c("i", {})
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a6cd4f0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a6cd4f0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/layout/section/Base.vue
// module id = 814
// module chunks = 0 1 55